import React from 'react';

import { AddressFragment } from '@graphql/platform';

const formatInlineAddress = (address: Omit<AddressFragment, 'id'>): string => {
  const cityStateZip = [address.city, address.state].filter(Boolean).join(', ');
  const locality = [cityStateZip, address.zip].filter(Boolean).join(' ');
  return [address.street, address.aptsuite, locality]
    .filter((part) => part && String(part).trim())
    .join(', ');
};

export const Address: React.FunctionComponent<{
  address: Omit<AddressFragment, 'id'>;
  className?: string;
  /** Single-line address (e.g. confirm-reservation Arrival details). */
  inline?: boolean;
}> = ({ address, className, inline = false }) =>
  inline ? (
    <div className={className}>{formatInlineAddress(address)}</div>
  ) : (
    <div className={className}>
      <div>{address.street}</div>
      {address.aptsuite && <div>{address.aptsuite}</div>}
      <div>
        {address.city}, {address.state} {address.zip}
      </div>
    </div>
  );
